import api from "./api";

// Autentifikatsiya yordamchilari (backend JWT bilan)
export async function login(phone, password) {
  const { data } = await api.post("/api/auth/login", { phone, password });
  if (data && data.token) {
    localStorage.setItem("token", data.token);
    localStorage.setItem("role", data.user?.role || "");
    localStorage.setItem("user", JSON.stringify(data.user || {}));
  }
  return data;
}

export function logout() {
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  localStorage.removeItem("user");
}

export function isAuthenticated() {
  return !!localStorage.getItem("token");
}

export function getRole() {
  return localStorage.getItem("role") || "";
}

export function getUser() {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    return {};
  }
}
